import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Redirect } from "react-router";
import { actionCreators as roomActions } from "../../state/ducks/room";

import { Classic as RoomLayout } from "../layouts";

const randomUsername = () => `user_${Math.floor(Math.random() * 1000)}`;

function Room({ location }) {
  const room = useSelector((state) => state.room);
  const dispatch = useDispatch();
  const { roomId, pin, adminSecret } = useParams();

  useEffect(() => {
    if (room.loggedIn) return;
    const params = new URLSearchParams(location.search);
    const username = params.get("user") || randomUsername();
    const adminLogin = params.get("admin");
    dispatch(roomActions.login(username, roomId, pin, adminSecret, adminLogin));
  }, []);

  if (room.error) {
    return <Redirect to="/" />;
  }

  return <RoomLayout />;
}

export default Room;
